import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

function PrivateRoute() {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  const XANO_BASE_URL = "https://api.sobevenda.com.br/api-proxy/affiliate";

  useEffect(() => {
    const validateSession = async () => {
      const token = localStorage.getItem("sobevenda_token");

      if (!token) {
        setAuthenticated(false);
        setLoading(false);
        window.location.href = "/login";
        return;
      }

      try {
        const { data } = await axios.get(`${XANO_BASE_URL}/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (data && data.id) {
          localStorage.setItem("sobevenda_user_id", data.id);
          setAuthenticated(true);
        } else {
          throw new Error("Sessão inválida");
        }
      } catch (err) {
        const msg = err?.response?.data?.message || "Sessão expirada. Faça login novamente.";
        toast.error(msg);
        
        localStorage.removeItem("sobevenda_token");
        localStorage.removeItem("sobevenda_user_id");
        setAuthenticated(false);
        
        setTimeout(() => {
          window.location.href = "/login";
        }, 500);
      } finally {
        setLoading(false);
      }
    };

    validateSession();

    // NOVO: Monitorar continuamente se o token ainda existe
    const checkTokenInterval = setInterval(() => {
      const token = localStorage.getItem("sobevenda_token");
      if (!token && authenticated) {
        // Token foi removido (provavelmente pelo interceptor)
        window.location.href = "/login";
      }
    }, 1000); // Verifica a cada 1 segundo

    return () => clearInterval(checkTokenInterval);
  }, [authenticated]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p>Validando sessão...</p>
      </div>
    );
  }

  if (!authenticated) {
    window.location.href = "/login";
    return null;
  }

  return <Outlet />;
}

export default PrivateRoute;